import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { ForgotPasswordFormSchema, ForgotPasswordMutation } from './ForgotPasswordForm.types';
import { getForgotPasswordForm } from './ForgotPasswordForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import { FORGOT_PASSWORD_QUERY_KEY, forgotPasswordQuery } from './ForgotPasswordForm.query';
import { registerSignUpStepData } from './ForgotPasswordForm.data';
import Form from '../../../../commons/Form/Form';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { UserRoles } from '../../../../../types/models/user/user.types';
import Loading from '../../../../commons/Loading/Loading';

export default () => {
  const { role } = useParams<{ role: UserRoles }>();

  const queryClient = useQueryClient();

  const [success, setSuccess] = useState(false);

  const formProps = useForm<ForgotPasswordFormSchema>({
    resolver: yupResolver(getForgotPasswordForm),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit } = formProps;

  const { mutate, isLoading } = useMutation<
    Awaited<ReturnType<ForgotPasswordMutation>>,
    Error,
    ForgotPasswordFormSchema
  >((data) => forgotPasswordQuery({ email: data.email, role }), {
    mutationKey: FORGOT_PASSWORD_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: () => {
      setSuccess(true);
    },
    onError: async (error) => alert(error.message),
  });

  const onSubmit = handleSubmit((data) => mutate(data));

  if (isLoading) return <Loading />;

  return (
    <>
      <Form<ForgotPasswordFormSchema>
        data={registerSignUpStepData}
        {...{ formProps, onSubmit }}
        isCompany={role === UserRoles.Entreprise}
        afterInputsElement={
          success && (
            <span className="form__after-inputs-text">
              Veuillez consulter vos mails pour réinitialiser votre mot de passe.
            </span>
          )
        }
      />
    </>
  );
};
